import Link from 'next/link';
import type { JSX } from 'react';
import { APP_ROUTES } from '@/shared/constants/app-routes';
import { buildAppRoute } from '@/shared/functions/build-app-route';

interface ILearnMoreIntroParagraph {
	id: string;
	title?: string;
	text: string;
	image_url?: string;
	wrapper_classname?: string;
	text_wrapper_classname?: string;
	text_classname?: string;
	title_classname?: string;
	image_wrapper_classname?: string;
	image_classname?: string;
}

export const LEARN_MORE_INTRO_PARAGRAPHS: ILearnMoreIntroParagraph[] = [
	{
		id: '1',
		text: `O Clube Pormade é o espaço onde profissionais da arquitetura, design e engenharia se conectam, evoluem e têm acesso a um universo de soluções exclusivas para quem transforma ambientes em experiências. 

No Clube, você encontra parceiros, conhecimento e referências que fazem a diferença no dia a dia dos seus projetos. Você tem acesso a eventos, viagens e uma rede de profissionais de alto nível, por isso, o Clube Pormade foi criado para quem quer crescer com propósito e entregar sempre o melhor.`,
		text_wrapper_classname: 'flex flex-col gap-4 w-full p-4',
		text_classname: 'whitespace-pre-wrap text-xl font-normal leading-relaxed text-pretty',
	},
	{
		id: '2',
		title: 'Experiências',
		text: `Fazer parte do Clube Pormade é vivenciar o melhor do mercado em primeira mão. De visitas técnicas a viagens únicas, cada momento é pensado para ampliar seu repertório criativo e fortalecer sua atuação profissional.
          
Aqui, conhecimento e inspiração andam juntos.`,
		text_wrapper_classname: 'flex flex-col gap-4 md:w-1/2 p-4',
		image_url: '/assets/images/learn-more/experiences.jpg',
		wrapper_classname: 'flex md:flex-row flex-col-reverse items-center justify-between gap-4',
		text_classname: 'whitespace-pre-wrap text-left text-lg font-normal leading-relaxed text-pretty',
		title_classname: 'text-left sm:text-5xl text-4xl font-normal text-clube-black font-playflair',
		image_wrapper_classname: 'relative w-full md:w-1/2 aspect-video',
		image_classname: 'size-full object-cover',
	},
	{
		id: '3',
		title: 'Networking',
		text: `Se conecte com os principais nomes da arquitetura e design. O Clube Pormade reúne profissionais que compartilham a mesma paixão, criando um ambiente fértil para parcerias, trocas e novas oportunidades de negócio. Sua rede profissional pode se tornar ainda mais poderosa!`,
		text_wrapper_classname: 'flex flex-col gap-4 md:w-1/2 p-4',
		image_url: '/assets/images/learn-more/networking.jpg',
		wrapper_classname: 'flex md:flex-row-reverse flex-col-reverse items-center justify-between gap-4',
		text_classname: 'whitespace-pre-wrap text-left text-lg font-normal leading-relaxed text-pretty',
		title_classname: 'text-left sm:text-5xl text-4xl font-normal text-clube-black font-playflair',
		image_wrapper_classname: 'relative w-full md:w-1/2 aspect-video',
		image_classname: 'size-full object-cover',
	},
	{
		id: '4',
		title: 'Eventos Exclusivos',
		text: `Nossos eventos são pensados para quem leva o design a sério. Encontros presenciais com especialistas do setor, workshops e acesso antecipado à lançamentos, tudo para que você esteja sempre à frente do mercado. `,
		text_wrapper_classname: 'flex flex-col gap-4 md:w-1/2 p-4',
		image_url: '/assets/images/learn-more/events.jpg',
		wrapper_classname: 'flex md:flex-row flex-col-reverse items-center justify-between gap-4',
		text_classname: 'whitespace-pre-wrap text-left text-lg font-normal leading-relaxed text-pretty',
		title_classname: 'text-left sm:text-5xl text-4xl font-normal text-clube-black font-playflair',
		image_wrapper_classname: 'relative w-full md:w-1/2 aspect-video',
		image_classname: 'size-full object-cover',
	},
	{
		id: '5',
		title: 'Suporte Especializado',
		text: `O Clube Pormade tem uma equipe dedicada para entender seus projetos e oferecer as melhores soluções em acabamentos. O suporte do Clube Pormade não é apenas um atendimento diferenciado, é realmente uma parceria técnica que acompanha cada etapa da criação, do projeto e da entrega.`,
		text_wrapper_classname: 'flex flex-col gap-4 md:w-1/2 p-4',
		image_url: '/assets/images/learn-more/support.jpg',
		wrapper_classname: 'flex md:flex-row-reverse flex-col-reverse items-center justify-between gap-4',
		text_classname: 'whitespace-pre-wrap text-left text-lg font-normal leading-relaxed text-pretty',
		title_classname: 'text-left sm:text-5xl text-4xl font-normal text-clube-black font-playflair',
		image_wrapper_classname: 'relative w-full md:w-1/2 aspect-video',
		image_classname: 'size-full object-cover object-bottom',
	},
];

interface ILearnMorePreRegisterTexts {
	title: string;
	paragraphs: JSX.Element | JSX.Element[];
}

export const LEARN_MORE_PRE_REGISTER_TEXTS: ILearnMorePreRegisterTexts = {
	title: 'Faça parte da comunidade do Clube Pormade',
	paragraphs: (
		<div className="flex flex-col gap-4">
			<p key="1">Acesse o seu espaço exclusivo e acompanhe experiências, benefícios e o seu progresso no Clube.</p>
			<p key="2" className="text-base sm:text-lg">
				Clique{' '}
				<Link className="underline" href={buildAppRoute(APP_ROUTES.EXTERNAL.SUPPORT)} target="_blank" rel="noopener noreferrer">
					aqui
				</Link>{' '}
				e entre em contato conosco.
			</p>
		</div>
	),
};
